import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { AutocompleteV } from 'components'; 
import { getStates, getCities } from './service';

export default function ProvinceCityListComponent({
  methods, 
  initialStateId = null,
  initialCityId = null,
  initialState = null,
  initialCity = null,
  isRequired = false
}) {
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  // مقادیر انتخاب شده (برای forceValue کردن city)
  const [province, setProvince] = useState(null); // name
  const [provinceId, setProvinceId] = useState(initialStateId);
  const [city, setCity] = useState(null);
  const [cityId, setCityId] = useState(initialCityId);

  useEffect(() => {
    let mounted = true;
    async function loadStates() {
      try {
        const s = await getStates();
        if (!mounted) return;
        const formatted = s.map((st) => ({ id: st.id, label: st.name, value: st.name }));
        setStates(formatted);

        if (initialState) {
          const found = formatted.find(a => a.label === initialState);
          methods.setValue('state', found);
          setProvince(found.label);
          setProvinceId(found.id);
          await loadCitiesForState(found.id, found.label, initialCity || initialState);
        }
      } catch (err) {
        console.error('loadStates error', err);
      }
    }
    loadStates();
    return () => { mounted = false; };
  }, []);

  // helper to load cities for a state
  async function loadCitiesForState(stateId, stateName, initialc) {
    try {
      const c = await getCities(stateId, stateName);
      // normalize to AutocompleteV format
      const formatted = c.map((ci) => ({ id: ci.cityId, label: ci.name, value: ci.name }));
      setCities(formatted);


      if (initialc) {
        const found = formatted.find(a => a.label === initialc);
        setCity(found);
        methods.setValue('city', found);
      }


    } catch (err) {
      console.error('loadCitiesForState error', err);
      setCities([]);
    }
  }

  // وقتی استان تغییر کرد
  async function handleProvinceChange(p) {
    // p میتونه null یا {id, label}
    const newProvince = p?.label ?? null;
    const newProvinceId = p?.id ?? null;

    setProvince(newProvince);
    setProvinceId(newProvinceId);
    methods.setValue('state', p);
    // پاک کردن شهر انتخاب‌شده قبلی
    setCity(null);
    setCityId(null);
    if (methods && methods.setValue) methods.setValue('city', null);

    if (newProvinceId) {
      await loadCitiesForState(newProvinceId, newProvince);
    } else {
      setCities([]);
    }
  }

  // وقتی شهر تغییر کرد
  function handleCityChange(c) {
    const newCityId = c?.id ?? null;
    setCity(c);
    setCityId(newCityId);
    methods.setValue('city', c);
  }

  return (
    <>
      <Grid item md={6} xs={12}>
        <AutocompleteV
          control={methods.control}
          errors={methods.formState.errors}
          register={methods.register}
          name="state"
          label="استان"
          list={states}
          preventAddCustomOption
          onChangeValue={(p) => handleProvinceChange(p)}
          rules={isRequired && ['required']}
        />
      </Grid>

      <Grid item md={6} xs={12}>
        <AutocompleteV
          control={methods.control}
          errors={methods.formState.errors}
          register={methods.register}
          name="city"
          label="شهر"
          preventAddCustomOption
          list={cities}
          onChangeValue={(c) => handleCityChange(c)}
          forceValue={city}
          rules={isRequired && ['required']}
          
        />
      </Grid>
    </>
  );
}
